import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { isDataLayerToolActiveSelector } from '~/store/frontendState/mapTools/dataLayers/dataLayers.selectors';
import { boundaryToolFiltersSelector } from '~/store/mapSettings/toolsState/boundary/mapSettingsToolsStateBoundary.selectors';
import type {
  BoundaryFilter, FilteredBoundaryItems,
} from '~/store/mapSettings/toolsState/boundary/mapSettingsToolsStateBoundary.state';
import { dataLayersFiltersSelector } from '~/store/mapSettings/toolsState/dataLayers/mapSettingsToolsStateDataLayers.selectors';

export type BoundaryFiltersGeneric<T extends FilteredBoundaryItems> = {
  get: (boundaryGroupId: BoundaryGroupId) => T;
  entries: ReadonlyArray<{ boundaryGroupId: BoundaryGroupId; filter: T }>;
};

export type BoundaryFilters = BoundaryFiltersGeneric<BoundaryFilter>;

export const boundaryFiltersSelector = createStateSelector([
  dataLayersFiltersSelector,
  boundaryToolFiltersSelector,
  isDataLayerToolActiveSelector,
], (dataLayerFilters, boundaryToolFilters, isDataLayerToolActive): BoundaryFilters => (
  isDataLayerToolActive ? dataLayerFilters : boundaryToolFilters
));

export const useBoundaryFilters = () => useSelector(boundaryFiltersSelector);
